import { getStore } from '@/utils/dva'
import Cookies from 'js-cookie'
import { cookiesDomain } from '@/utils/token'

const PROGRESS_EXPIRES = 1 // 缓存1天
const PROGRESS_LOCAL_CACHE = 'PROGRESS_LOCAL_CACHE' // 本地缓存key

const getUid = () => {
    const $store = getStore()
    const currentUser = $store.getState()?.user?.currentUser

    return currentUser.uid
}

const cookie = {
    set(key, value) {
        Cookies.set(key, JSON.stringify(value), {
            expires: PROGRESS_EXPIRES,
            domain: cookiesDomain,
            Secure: true,
            SameSite: 'None',
        })
    },
    get(key) {
        let values
        try {
            const data = Cookies.get(key)
            if (data) {
                values = JSON.parse(data)
            }
        } catch (error) {
            console.error('catchError', error)
            values = Cookies.get(key)
        }
        return values
    },
    remove(key) {
        Cookies.remove(key, {
            expires: PROGRESS_EXPIRES,
            domain: cookiesDomain,
        })
    },
}

export const getProgressTasks = () => {
    const uid = getUid()
    const progressTasks = cookie.get(`${PROGRESS_LOCAL_CACHE}_${uid}`)

    try {
        const tasks = progressTasks
        if (Array.isArray(tasks)) {
            return tasks
        } else {
            return []
        }
    } catch (error) {
        console.error('catchError', error)
        return []
    }
}

export const saveProgressTasks = ({ progressTasks, currentUser }) => {
    cookie.set(`${PROGRESS_LOCAL_CACHE}_${currentUser?.uid}`, progressTasks)
}
